export enum ContractDisplaySetting {
  Name = 'name',
  Description = 'description',
  Title = 'title',
  Company = 'company',
  Email = 'email',
}
